import React from 'react';

const EwaybillCredentialFields = ({ formData, onChange, embedded = false }) => {
  if (!formData?.can_access?.ewaybill) {
    return null;
  }

  return (
    <div>
      {!embedded && (
        <h3 className="text-base sm:text-md font-semibold text-gray-700 mb-3 sm:mb-4 pb-2 border-b-2 border-grey-400">
          E-Way Bill (PeriOne)
        </h3>
      )}
      <p className="text-xs sm:text-sm text-gray-500 mb-3">
        GSTIN uses the company GST number. Username and password are this
        company's e-Way Bill API login. The username and password in .env are not used.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-6">
        <div>
          <label className="block text-xs sm:text-sm font-medium text-secondary mb-1 sm:mb-2">
            GSTIN
          </label>
          <input
            type="text"
            value={formData.gst_number || ''}
            disabled
            className="w-full px-3 sm:px-4 py-2 border border-gray-200 rounded-xl bg-gray-50 text-sm sm:text-base text-gray-600"
          />
          <p className="text-xs text-gray-400 mt-1">From company GST number</p>
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-secondary mb-1 sm:mb-2">
            Username
          </label>
          <input
            type="text"
            name="ewaybill_username"
            value={formData.ewaybill_username || ''}
            onChange={onChange}
            placeholder="PeriOne username"
            className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            autoComplete="off"
          />
        </div>
        <div>
          <label className="block text-xs sm:text-sm font-medium text-secondary mb-1 sm:mb-2">
            Password
          </label>
          <input
            type="password"
            name="ewaybill_password"
            value={formData.ewaybill_password || ''}
            onChange={onChange}
            placeholder={formData.has_ewaybill_password ? '•••••••• (leave blank to keep)' : 'Enter password'}
            className="w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-400 text-sm sm:text-base"
            autoComplete="new-password"
          />
        </div>
      </div>
    </div>
  );
};

export default EwaybillCredentialFields;
